import { HighlightLines } from "./Axis";
import type { ScatterplotOverlayProps } from "./scatterplotTypes";

const ScatterplotOverlay = ({
  activeItem,
  highlightedItem,
  filteredDataLookup,
  totalExportLookup,
  metaDataLookup: _metaDataLookup,
  ySelection,
  width,
  height,
  yPadding,
  zoom,
  zoomedXScale,
  zoomedYScale,
  zoomTransform,
  productClass: _productClass,
  setHighlightedItem: _setHighlightedItem,
}: ScatterplotOverlayProps) => {
  return (
    <>
      <g clipPath="url(#zoom-clip)">
        <HighlightLines
          activeItem={activeItem}
          filteredDataLookup={filteredDataLookup}
          width={width}
          height={height}
          yPadding={yPadding}
          zoom={zoom}
          zoomedXScale={zoomedXScale}
          zoomedYScale={zoomedYScale}
          ySelection={ySelection}
          totalExportLookup={totalExportLookup}
        />
        {highlightedItem && (
          <g transform={zoomTransform}>
            <circle
              r={filteredDataLookup.get(highlightedItem)?.r}
              cx={filteredDataLookup.get(highlightedItem)?.cx}
              cy={filteredDataLookup.get(highlightedItem)?.cy}
              fill={filteredDataLookup.get(highlightedItem)?.fill}
              style={{ pointerEvents: "none" }}
              stroke="rgb(70, 70, 90)"
              strokeWidth={2}
            />
          </g>
        )}
      </g>
    </>
  );
};

export default ScatterplotOverlay;
